export default __webpack_public_path__ + "static/media/icon-faq.bd484e73.svg";